// extracted by mini-css-extract-plugin
export default {"registry-totals-container":"fbyRhnPGtu","registryTotalsContainer":"fbyRhnPGtu","registry-total-box":"XR8lXEvwKc","registryTotalBox":"XR8lXEvwKc"};